import type { UserRole } from '../../models';

/**
 * Only allow same-origin in-app paths (no protocol / open redirects).
 */
export function sanitizeInternalReturnUrl(raw: string | null | undefined): string | null {
  if (!raw || typeof raw !== 'string') return null;
  const s = raw.trim();
  if (!s.startsWith('/') || s.startsWith('//')) return null;
  if (s.includes('://')) return null;
  if (s.length > 2048) return null;
  return s;
}

export function isReturnUrlAllowedForRole(url: string, role: UserRole): boolean {
  if (role === 'client') return url.startsWith('/client');
  if (role === 'cleaner') return url.startsWith('/cleaner');
  if (role === 'admin') return url.startsWith('/admin');
  return false;
}
